import { Contact, EnumEventLocationLocationInfoType } from "gql/generated";
import { getMultilingualString } from "shared/utils";
import _ from "lodash";
import { LocationListData } from "apps/events/types/LocationListData";

type EventCreationOperator = {
  _entityId?: string | null;
  name?: Parameters<typeof getMultilingualString>[0];
  contact?: Pick<Contact, "email" | "phone" | "address"> & {
    links?: Pick<NonNullable<Contact["links"]>, "website"> | null;
  };
  enrollments?: Array<{
    organization?: { _id?: string | null } | null;
    onboardingStatus?: string | null;
  } | null>;
};

export const mapOperatorsToLocationListData = (
  operators: EventCreationOperator[],
): LocationListData[] => {
  const seen = new Set<string>();
  const mapped = operators
    .filter(operator => {
      if (!operator._entityId) return false;
      if (seen.has(operator._entityId)) return false;
      seen.add(operator._entityId);
      return true;
    })
    .map(operator => ({
      label: getMultilingualString(operator.name ?? {}).trim(),
      value: operator._entityId!,
      data: {
        locationInfo: {
          _entityId: operator._entityId!,
          type: EnumEventLocationLocationInfoType.Operator,
        },
        venue: operator.name ?? {},
        contact: operator.contact as Contact | undefined,
        enrollments: (operator.enrollments ?? [])
          .filter(
            (enrollment): enrollment is NonNullable<typeof enrollment> =>
              !!enrollment?.organization?._id,
          )
          .map(enrollment => ({
            organizationId: enrollment.organization!._id!,
            isActive: enrollment.onboardingStatus === "COMPLETED_ONBOARDING",
          })),
      },
    }));

  return _.sortBy(mapped, "label");
};
